import { render } from "./SupportCommande.vue?vue&type=template&id=00b7a1fa"
import script from "./SupportCommande.vue?vue&type=script&lang=ts"
export * from "./SupportCommande.vue?vue&type=script&lang=ts"
script.render = render

export default script